import { RootState } from '@store';

const notificationsSelector = (state: RootState) => state.notifications.items;
const canShowNotificationsSelector = (state: RootState) => state.notifications.canShow;

export { notificationsSelector, canShowNotificationsSelector };
